const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const defaultApiOrigin = browserOrigin || 'http://localhost';
const configuredApiOrigin = process.env.REACT_APP_API_ORIGIN;
const configuredLocationsApiOrigin = process.env.REACT_APP_LOCATIONS_API_ORIGIN;

const normalizeConfiguredOrigin = (origin?: string) => {
  const value = String(origin || '').trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value.replace(/\/$/, '');
  return `https://${value.replace(/^\/+/, '').replace(/\/$/, '')}`;
};

const normalizedConfiguredApiOrigin = normalizeConfiguredOrigin(configuredApiOrigin);
const normalizedConfiguredLocationsApiOrigin = normalizeConfiguredOrigin(configuredLocationsApiOrigin);
const isCrowdTradesDevHost = Boolean(browserOrigin && /crowdtradesdev\.kenwayne\.me/i.test(browserOrigin));
const EVENTS_API_ORIGIN = normalizedConfiguredApiOrigin || defaultApiOrigin;
const LOCATIONS_API_ORIGIN = normalizedConfiguredLocationsApiOrigin || normalizedConfiguredApiOrigin || defaultApiOrigin;

const parseOriginPort = (origin: string) => {
  try {
    return new URL(origin).port;
  } catch {
    return '';
  }
};

const eventsOriginAlreadyHasPort = Boolean(parseOriginPort(EVENTS_API_ORIGIN));
const locationsOriginAlreadyHasPort = Boolean(parseOriginPort(LOCATIONS_API_ORIGIN));
const shouldInferEventPort = !configuredApiOrigin;
const shouldInferLocationPort = !configuredLocationsApiOrigin && !configuredApiOrigin;
const EVENTS_API_PORT = process.env.REACT_APP_EVENTS_API_PORT || (shouldInferEventPort && !eventsOriginAlreadyHasPort ? (isCrowdTradesDevHost ? '' : '4000') : '');
const LOCATIONS_API_PORT = process.env.REACT_APP_LOCATIONS_API_PORT || (shouldInferLocationPort && !locationsOriginAlreadyHasPort ? (isCrowdTradesDevHost ? '' : '4001') : '');

const appendPort = (origin: string, port: string) => {
  if (!port) return origin;
  return `${origin}:${port}`;
};

export const EVENTS_API_BASE = appendPort(EVENTS_API_ORIGIN, EVENTS_API_PORT);
export const LOCATIONS_API_BASE = appendPort(LOCATIONS_API_ORIGIN, LOCATIONS_API_PORT);

export const buildEventsApiUrl = (path: string) => `${EVENTS_API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
export const buildLocationsApiUrl = (path: string) => `${LOCATIONS_API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
